import {
  RECEIVE_SETTINGS,
  REQUEST_SETTINGS,
  SETTINGS_UPDATE_AVATAR_URL,
  SETTINGS_UPDATE_DEFAULT_LOCATION,
  SETTINGS_UPDATE_EMAIL,
  SETTINGS_UPDATE_FIRST_NAME,
  SETTINGS_UPDATE_LAST_NAME,
  SETTINGS_UPDATE_PHONE_NUMBER,
  SETTINGS_UPDATE_TIMEZONE,
  SETTINGS_UPDATE_VIRTUAL_INFO,
} from './actions'
import { SettingsActionType, SettingsStore } from './types'

const initalState: SettingsStore = {
  user_id: 0,
  first_name: '',
  last_name: '',
  email: '',
  phone_number: '',
  virtual_info: '',
  default_location: '',
  default_agenda: 0,
  timezone: '',
  avatar_url: '',
  calendars: [],
  upload_avatar_succeeded: false,
  companies: [],
  integrations: [],
  isFetching: false,
  preferred_times: [],
  onboarding: null,
  tier: null,
  ranges: [],
}

export const reducer = (
  state = initalState,
  action: SettingsActionType,
): SettingsStore => {
  switch (action.type) {
    case SETTINGS_UPDATE_AVATAR_URL:
      return {
        ...state,
        avatar_url: action.avatar_url,
      }
    case SETTINGS_UPDATE_FIRST_NAME:
      return {
        ...state,
        first_name: action.first_name,
      }
    case SETTINGS_UPDATE_LAST_NAME:
      return {
        ...state,
        last_name: action.last_name,
      }
    case SETTINGS_UPDATE_EMAIL:
      return {
        ...state,
        email: action.email,
      }
    case SETTINGS_UPDATE_PHONE_NUMBER:
      return {
        ...state,
        phone_number: action.phone_number,
      }
    case SETTINGS_UPDATE_VIRTUAL_INFO:
      return {
        ...state,
        virtual_info: action.virtual_info,
      }
    case SETTINGS_UPDATE_DEFAULT_LOCATION:
      return Object.assign({}, state, {
        default_location: action.default_location,
      })

    case SETTINGS_UPDATE_TIMEZONE:
      return {
        ...state,
        timezone: action.timezone,
      }

    case REQUEST_SETTINGS:
      return {
        ...state,
        isFetching: true,
      }
    case RECEIVE_SETTINGS:
      return {
        ...state,
        user_id: action.settings.information.id,
        first_name: action.settings.information.first_name,
        last_name: action.settings.information.last_name,
        email: action.settings.information.email,
        phone_number: action.settings.information.phone_number,
        default_location: action.settings.information.default_location,
        default_agenda: action.settings.information.default_agenda,
        avatar_url: action.settings.information.avatar_url,
        calendars: action.settings.information.calendars,
        timezone: action.settings.information.timezone,
        virtual_info: action.settings.information.virtual_info,
        companies: action.settings.companies,
        integrations: action.settings.integrations,
        tier: action.settings.information.tier,
        preferred_times: action.settings.preferred_times,
        onboarding: action.settings.onboarding,
        ranges: action.settings.preferences.preferred_times,
        isFetching: false,
      }
    default:
      return state
  }
}
